import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const LoadingSkeleton = () => {
    return (
        <Stack
            background={colorsPalettes.carbon[0]}
            gap="16px"
            padding="16px"
            height="100%"
            justifyContent="space-around"
        >
            <Flex width="66%">
                <PixelPlaceholderLoader
                    width="100%"
                    height="16px"
                />
            </Flex>
            <Flex width="50%">
                <PixelPlaceholderLoader
                    width="100%"
                    height="32px"
                />
            </Flex>
            <Flex width="100%">
                <PixelPlaceholderLoader
                    width="100%"
                    height="56px"
                />
            </Flex>
        </Stack>
    );
};
